// 1Rotary — Automated Financial Reporting Center
// Strategic Paper, Domain 6 Use Case 5: 4 standard auto-generated reports.
// Each report has frequency, last-run, status, AI executive summary, KPIs,
// and a deterministic mock CSV preview (top 8 rows + totals row).

let _s = 23456;
function rnd() { _s = (_s * 1664525 + 1013904223) % 4294967296; return _s / 4294967296; }
function ri(a, b) { return Math.floor(rnd() * (b - a + 1)) + a; }

// --- helpers to fabricate CSV-ish row arrays for each report ----------
function dailySalesRows() {
  _s = 11111;
  const branches = ["NCR-Pasig", "NCR-QC", "NCR-Makati", "NCR-Mandaluyong", "Cebu-Mandaue", "Davao-Matina", "Iloilo-Mandurriao", "Pampanga-SF"];
  return branches.map((b, i) => {
    const rev = ri(820_000, 2_400_000);
    const tx = ri(140, 480);
    const aov = Math.round(rev / tx);
    const gm = +(0.26 + rnd() * 0.12).toFixed(3);
    const target = Math.round(rev * (0.88 + rnd() * 0.22));
    const ach = +(rev / target).toFixed(3);
    return { branch: b, transactions: tx, revenue: rev, aov, grossMargin: gm, target, achievement: ach };
  });
}
function weeklyInventoryRows() {
  _s = 22222;
  const cats = ["HVAC Compressors", "Auto AC Parts", "Refrigerant Gases", "Filters & Driers", "Consumables", "Tools & Gauges", "Cold-Chain Refrig", "Service Spare Parts"];
  return cats.map(c => {
    const onhand = ri(2_400, 22_000);
    const cogs = ri(48_000_000, 240_000_000);
    const value = Math.round(cogs * (0.08 + rnd() * 0.18));
    const turnover = +(cogs / value).toFixed(2);
    const dsi = Math.round(365 / turnover);
    const overstock = +(rnd() * 0.18).toFixed(3);
    return { category: c, onHandUnits: onhand, inventoryValue: value, cogs90d: cogs, turnover, dsi, overstockShare: overstock };
  });
}
function monthlyBranchPnLRows() {
  _s = 33333;
  const branches = ["NCR-Pasig", "NCR-QC", "Cebu-Mandaue", "Davao-Matina", "Iloilo-Mandurriao", "Pampanga-SF", "Cagayan de Oro", "Calapan"];
  return branches.map(b => {
    const revenue = ri(28_000_000, 84_000_000);
    const cogs = Math.round(revenue * (0.62 + rnd() * 0.08));
    const opex = Math.round(revenue * (0.14 + rnd() * 0.06));
    const grossProfit = revenue - cogs;
    const ebitda = grossProfit - opex;
    const margin = +(ebitda / revenue).toFixed(3);
    return { branch: b, revenue, cogs, grossProfit, opex, ebitda, ebitdaMargin: margin };
  });
}
function quarterlySupplierRows() {
  _s = 44444;
  const suppliers = ["Sanden Phils.", "Daikin Industries", "Capella Refrig", "Honeywell Refrig", "Mitsubishi HI", "Toyota Genuine", "ROTEK Compressors", "Local OEM Network"];
  return suppliers.map(s => {
    const pos = ri(24, 184);
    const value = ri(28_000_000, 220_000_000);
    const otd = +(0.72 + rnd() * 0.22).toFixed(3);
    const ltAcc = +(0.74 + rnd() * 0.2).toFixed(3);
    const costVar = +(-0.04 + rnd() * 0.12).toFixed(3);
    const qcReject = +(rnd() * 0.04).toFixed(4);
    return { supplier: s, pos, poValue: value, onTimeDelivery: otd, leadTimeAccuracy: ltAcc, costVariance: costVar, qcReject };
  });
}

function branchInvSummaryRows() {
  _s = 55555;
  const branches = ["NCR-Pasig Ortigas", "NCR-Makati", "NCR-QC Cubao", "Cebu-Mandaue", "Davao-Matina", "Iloilo-Mandurriao", "Pampanga-SF", "Baguio", "Cagayan de Oro", "Batangas City"];
  return branches.map(b => {
    const onhand = ri(3_200, 18_400);
    const value = ri(2_800_000, 11_400_000);
    const doh = +(20 + rnd() * 55).toFixed(1);
    const stockA = ri(2, 18);
    const overC = ri(4, 42);
    const acc = +(0.92 + rnd() * 0.075).toFixed(3);
    return { branch: b, onHandUnits: onhand, inventoryValue: value, dsi: doh, stockoutA: stockA, overstockC: overC, inventoryAccuracy: acc };
  });
}
function weeklyReorderRows() {
  _s = 66666;
  const clusters = [
    { cluster: "Pasig WH (NCR)", branches: 27 },
    { cluster: "Cebu WH (Visayas)", branches: 12 },
    { cluster: "Davao WH (Mindanao)", branches: 8 },
    { cluster: "Pampanga WH (North Luzon)", branches: 18 },
    { cluster: "Batangas WH (South Luzon)", branches: 21 },
  ];
  const skus = ["Freon R32 9.5kg", "Sanden SD7H15 Compressor", "Inverter Compressor 1.5HP", "Capella Auto TM-16", "Copper Tubing 1/4\" 15m", "Panasonic Refrig Compressor 1/4HP", "Rotary 1.0HP", "Fan Capacitor 6µF", "Drier Filter 083", "Thermostat Cabin 12V"];
  // Round-robin: exactly 3 rows per cluster × 5 clusters = 15 rows (SOW: all 5 clusters visible in preview)
  const rows = [];
  clusters.forEach((c, ci) => {
    for (let n = 0; n < 3; n++) {
      const s = skus[(ci * 3 + n) % skus.length];
      const qty = ri(120, 4_800);
      const moq = ri(48, 480);
      const suggested = Math.ceil(qty / moq) * moq;
      const daysCover = +(rnd() * 12 + 6).toFixed(1);
      const confidence = +(0.72 + rnd() * 0.24).toFixed(2);
      rows.push({ cluster: c.cluster, sku: s, currentOnHand: ri(80, 620), aiForecast: qty, moqAdjusted: suggested, daysCover, aiConfidence: confidence });
    }
  });
  return rows;
}
function deadstockRows() {
  _s = 77777;
  const skus = [
    { sku: "Foam Filter Roll Eco", origin: "Davao Matina" },
    { sku: "Door Gasket Magnetic 24in", origin: "Iloilo Mandurriao" },
    { sku: "Kia Picanto Idler Pulley", origin: "Cagayan de Oro" },
    { sku: "Chevrolet Sail Bracket Kit", origin: "Zamboanga" },
    { sku: "Mazda 3 Expansion Valve", origin: "Cotabato" },
    { sku: "BMW 3-Series Discharge Hose", origin: "Butuan" },
    { sku: "Drier Filter 053", origin: "Vigan" },
    { sku: "Manifold Gauge Dual (legacy)", origin: "Aparri" },
  ];
  return skus.map(s => {
    const days = ri(182, 412);
    const units = ri(48, 620);
    const cost = ri(1_800, 18_400);
    const value = units * cost;
    const disposition = days > 300 ? "Shopee 4.4 Liquidation" : "Pooled Transfer → Pasig WH";
    const recoveryPct = +(disposition.includes("Liquidation") ? 0.62 + rnd() * 0.12 : 0.84 + rnd() * 0.10).toFixed(2);
    return {
      sku: s.sku,
      origin: s.origin,
      daysOnHand: days,
      units,
      inventoryValue: value,
      disposition,
      expectedRecovery: Math.round(value * recoveryPct),
    };
  });
}

export const REPORT_CENTER = [
  {
    id: "RPT-DAILY-SALES",
    name: "Daily Sales Summary",
    cadence: "Daily · 06:00 PHT",
    owner: "CFO Office",
    audience: ["CEO", "VP Operations", "CFO", "Regional Managers"],
    lastRun: "2026-02-18 06:00",
    nextRun: "2026-02-19 06:00",
    status: "ready",
    period: "Feb 17, 2026 (Tue)",
    rowCount: 158,
    deliveryChannels: ["Email", "Teams", "Fabric Workspace"],
    columns: ["Branch", "Transactions", "Revenue (₱)", "AOV (₱)", "Gross Margin", "Target (₱)", "Achievement"],
    columnKeys: ["branch", "transactions", "revenue", "aov", "grossMargin", "target", "achievement"],
    formats: { revenue: "peso", aov: "peso", target: "peso", grossMargin: "pct", achievement: "pct" },
    rows: dailySalesRows(),
    kpis: [
      { label: "Network Revenue (yesterday)", value: 142_840_000, fmt: "peso", delta: 0.082, status: "success" },
      { label: "Branches above target", value: "118 / 158", delta: 0.044, status: "success" },
      { label: "Avg Gross Margin", value: 0.318, fmt: "pct", delta: 0.012, status: "success" },
      { label: "Critical underperformers", value: 8, status: "warning" },
    ],
    aiExec:
      "Yesterday's network revenue was ₱142.8M (+8.2% DoD, +14.4% YoY), with 118 of 158 branches achieving target. NCR-Pasig led at 124% achievement on Shopee anchor halo. Eight branches (Calapan, Vigan, Cotabato, Aparri, Solano, Daet, Tagum, Iba) remained below 75% — all 3-year action-or-close candidates. Avg GM lifted +1.2pp on direct-channel mix tilt. Recommend prioritizing replenishment escalation for the 8 underperformers and lock-in the Shopee creative refresh that drove yesterday's NCR uplift.",
    confidence: 0.93,
  },
  {
    id: "RPT-WEEKLY-INV",
    name: "Weekly Inventory Value Report",
    cadence: "Weekly · Mon 07:00 PHT",
    owner: "Demand Planning",
    audience: ["CFO", "VP Operations", "Demand Planning Manager", "Merchandising"],
    lastRun: "2026-02-17 07:00",
    nextRun: "2026-02-24 07:00",
    status: "ready",
    period: "Week 7, 2026 (Feb 10–16)",
    rowCount: 42,
    deliveryChannels: ["Email", "Fabric Workspace"],
    columns: ["Category", "On-Hand (u)", "Inventory Value (₱)", "COGS 90D (₱)", "Turnover", "DSI", "Overstock Share"],
    columnKeys: ["category", "onHandUnits", "inventoryValue", "cogs90d", "turnover", "dsi", "overstockShare"],
    formats: { inventoryValue: "peso", cogs90d: "peso", overstockShare: "pct" },
    rows: weeklyInventoryRows(),
    kpis: [
      { label: "Total Inventory Value", value: 928_400_000, fmt: "peso", delta: -0.028, status: "success" },
      { label: "Network Turnover", value: "9.4×", delta: 0.064, status: "success" },
      { label: "Network DSI", value: "38.7 d", delta: -0.041, status: "success" },
      { label: "Overstock Share", value: 0.118, fmt: "pct", delta: 0.004, status: "warning" },
    ],
    aiExec:
      "Inventory value down ₱26.8M WoW to ₱928.4M as a planned reduction of HVAC C-class slow-movers progressed. Network turnover lifted to 9.4× (target ≥ 8.5×); DSI tightened by 1.6 days. Overstock share crept to 11.8% (target < 10%) — Refrig category DSI at 54 days is the lead drag. Recommend executing the 8 AI auto-replenishment moves (₱14.2M, 96% confidence) and triggering Refrig safety-stock rebalance to release ~₱8M working capital.",
    confidence: 0.91,
  },
  {
    id: "RPT-MONTHLY-PNL",
    name: "Monthly Branch P&L Report",
    cadence: "Monthly · 1st BD 08:00 PHT",
    owner: "Finance",
    audience: ["CEO", "CFO", "VP Operations", "Regional Managers"],
    lastRun: "2026-02-03 08:00",
    nextRun: "2026-03-03 08:00",
    status: "ready",
    period: "January 2026",
    rowCount: 158,
    deliveryChannels: ["Email", "Teams", "Fabric Workspace", "Board Pack"],
    columns: ["Branch", "Revenue (₱)", "COGS (₱)", "Gross Profit (₱)", "OPEX (₱)", "EBITDA (₱)", "EBITDA Margin"],
    columnKeys: ["branch", "revenue", "cogs", "grossProfit", "opex", "ebitda", "ebitdaMargin"],
    formats: { revenue: "peso", cogs: "peso", grossProfit: "peso", opex: "peso", ebitda: "peso", ebitdaMargin: "pct" },
    rows: monthlyBranchPnLRows(),
    kpis: [
      { label: "Network Revenue (Jan)", value: 4_180_000_000, fmt: "peso", delta: 0.144, status: "success" },
      { label: "Network EBITDA", value: 698_000_000, fmt: "peso", delta: 0.184, status: "success" },
      { label: "EBITDA Margin", value: 0.167, fmt: "pct", delta: 0.018, status: "success" },
      { label: "Branches EBITDA-negative", value: 4, status: "critical" },
    ],
    aiExec:
      "January 2026 closed at ₱4.18B revenue (+14.4% YoY) and ₱698M EBITDA (+18.4% YoY), lifting margin 1.8pp to 16.7%. NCR-Pasig and Cebu-Mandaue together delivered 18% of network EBITDA. Four branches (Calapan, Cotabato, Vigan, Iba) printed negative EBITDA on persistent stockouts and over-staffing — formal 3-year review recommended. Promo-discount drag accelerated by 1.4pp; tightening the Shopee 11.11 SKU participation list to top-100 (from 240) is the highest-impact lever for Feb.",
    confidence: 0.94,
  },
  {
    id: "RPT-QTR-SUPPLIER",
    name: "Quarterly Supplier Performance Report",
    cadence: "Quarterly · QBR cycle",
    owner: "Procurement",
    audience: ["VP Operations", "CFO", "Merchandising", "Procurement Manager"],
    lastRun: "2026-01-12 09:00",
    nextRun: "2026-04-12 09:00",
    status: "draft",
    period: "Q4 2025 (Oct–Dec)",
    rowCount: 38,
    deliveryChannels: ["Email", "Supplier QBR Deck", "Fabric Workspace"],
    columns: ["Supplier", "POs", "PO Value (₱)", "On-Time Delivery", "Lead-Time Accuracy", "Cost Variance", "QC Reject"],
    columnKeys: ["supplier", "pos", "poValue", "onTimeDelivery", "leadTimeAccuracy", "costVariance", "qcReject"],
    formats: { poValue: "peso", onTimeDelivery: "pct", leadTimeAccuracy: "pct", costVariance: "pct", qcReject: "pct" },
    rows: quarterlySupplierRows(),
    kpis: [
      { label: "Suppliers in scope", value: 38 },
      { label: "Avg OTD", value: 0.842, fmt: "pct", delta: 0.024, status: "warning" },
      { label: "Avg Lead-Time Accuracy", value: 0.876, fmt: "pct", delta: 0.018, status: "success" },
      { label: "Cost Variance (favourable)", value: -0.012, fmt: "pct", status: "success" },
    ],
    aiExec:
      "Q4 2025 supplier scorecard shows OTD at 84.2% (below 85% target). Capella (78%) and Honeywell (74%) are the laggards — root cause is import lead-time slippage from Manila South port congestion (correlation R²=0.71). Tier-1 suppliers (Sanden, Daikin) operating at 92%+ OTD. Recommend (i) Capella renegotiation to Net-75 in exchange for an OTD SLO with penalty clause, and (ii) onboarding a secondary supplier for Honeywell-spec Refrig parts. Estimated combined working-capital + stockout-avoidance impact: ₱11M / quarter.",
    confidence: 0.88,
  },
  // ---------- SOW Lite Pilot D5 Reports (Inventory + Demand Forecast pilot) ----------
  {
    id: "RPT-BRANCH-INV-SUM",
    name: "Branch Inventory Summary",
    cadence: "Daily · 07:00 PHT",
    owner: "Demand Planning · Pilot",
    audience: ["Branch Head", "Regional Manager", "Demand Planning Manager", "Management"],
    lastRun: "2026-02-18 07:00",
    nextRun: "2026-02-19 07:00",
    status: "ready",
    period: "Feb 17, 2026 (close of business)",
    rowCount: 119,
    deliveryChannels: ["Email", "Teams", "Fabric Workspace"],
    columns: ["Branch", "On-Hand (u)", "Inventory Value (₱)", "DSI", "A-Class Stockouts", "C-Class Overstock", "Accuracy"],
    columnKeys: ["branch", "onHandUnits", "inventoryValue", "dsi", "stockoutA", "overstockC", "inventoryAccuracy"],
    formats: { inventoryValue: "peso", inventoryAccuracy: "pct" },
    rows: branchInvSummaryRows(),
    kpis: [
      { label: "Total Inventory Value (network)", value: 928_400_000, fmt: "peso", delta: -0.028, status: "success" },
      { label: "A-Class Stockout Rate", value: 0.047, fmt: "pct", delta: -0.008, status: "success" },
      { label: "Overstock Share (C-class)", value: 0.118, fmt: "pct", delta: 0.004, status: "warning" },
      { label: "Avg Inventory Accuracy", value: 0.962, fmt: "pct", delta: 0.006, status: "success" },
    ],
    aiExec:
      "Day-close snapshot across all 119 branches shows a healthy inventory position (₱928M, -2.8% WoW). A-class stockout rate down to 4.7% (target < 5%) driven by AI Auto-Replenishment moves executed Fri–Sun. Overstock persists in C-class (11.8%) — 8 candidates surfaced for the Dead-Stock report. Bottom-quartile accuracy branches (Cotabato, Vigan) require cycle-count re-training this week.",
    confidence: 0.92,
  },
  {
    id: "RPT-WEEKLY-REORDER",
    name: "Weekly AI Reorder Recommendations",
    cadence: "Weekly · Mon 08:00 PHT",
    owner: "Demand Planning · Pilot",
    audience: ["Demand Planning Manager", "Regional Manager", "Central Warehouse", "Management"],
    lastRun: "2026-02-17 08:00",
    nextRun: "2026-02-24 08:00",
    status: "ready",
    period: "Week 8, 2026 (Feb 17–23)",
    rowCount: 342,
    deliveryChannels: ["Email", "Fabric Workspace", "SAP S/4 export"],
    columns: ["Cluster / WH", "SKU", "Current On-Hand", "AI Forecast (wk)", "MOQ-Adjusted Qty", "Days Cover", "AI Confidence"],
    columnKeys: ["cluster", "sku", "currentOnHand", "aiForecast", "moqAdjusted", "daysCover", "aiConfidence"],
    formats: { aiConfidence: "pct" },
    rows: weeklyReorderRows(),
    kpis: [
      { label: "Reorder Recommendations", value: 342 },
      { label: "Total Suggested Value", value: 84_240_000, fmt: "peso", status: "info" },
      { label: "High-Confidence (≥ 0.85)", value: "218 / 342", delta: 0.14, status: "success" },
      { label: "SOW Forecast Accuracy", value: 0.812, fmt: "pct", delta: 0.024, status: "success" },
    ],
    aiExec:
      "342 reorder recommendations generated by ML-001 (Demand Forecast Auto v3.4) across 5 warehouse clusters. Top-3 highest-impact moves: (1) 4,800u Freon R32 → Pasig WH (₱5.9M, 96% conf); (2) 1,200u Sanden SD7H15 → Cebu WH (₱18.4M, 92% conf); (3) 2,400u Inverter 1.5HP → Pampanga WH (₱6.2M, 89% conf). All MOQ-adjusted per supplier contracts. Recommend one-click approval for the 218 high-confidence items and human review of the 124 medium-confidence items.",
    confidence: 0.89,
  },
  {
    id: "RPT-DEADSTOCK-CAND",
    name: "Dead-Stock Candidate List — Pooled Transfer & Liquidation",
    cadence: "Weekly · Fri 16:00 PHT",
    owner: "Merchandising · Pilot",
    audience: ["Demand Planning Manager", "Merchandising", "Regional Manager", "Management"],
    lastRun: "2026-02-14 16:00",
    nextRun: "2026-02-21 16:00",
    status: "ready",
    period: "Week 7, 2026",
    rowCount: 18,
    deliveryChannels: ["Email", "Fabric Workspace"],
    columns: ["SKU", "Origin Branch", "Days on Hand", "Units", "Inventory Value (₱)", "Disposition", "Expected Recovery (₱)"],
    columnKeys: ["sku", "origin", "daysOnHand", "units", "inventoryValue", "disposition", "expectedRecovery"],
    formats: { inventoryValue: "peso", expectedRecovery: "peso" },
    rows: deadstockRows(),
    kpis: [
      { label: "SKUs flagged (≥180d DoH)", value: 18 },
      { label: "Locked Inventory Value", value: 4_820_000, fmt: "peso", status: "warning" },
      { label: "Est. Working-Capital Recovery", value: 3_640_000, fmt: "peso", delta: 0.28, status: "success" },
      { label: "Pooled Transfer → Pasig WH", value: "12 SKUs", status: "info" },
    ],
    aiExec:
      "Dead-Stock Detector (180-day threshold) surfaced 18 SKUs holding ₱4.82M in working capital. 12 SKUs routed to Pooled Transfer → Pasig WH (higher-velocity destinations identified); 6 SKUs routed to Shopee 4.4 Liquidation at avg -22% discount. Expected total recovery ₱3.64M (75%). No B-class or A-class SKUs in this batch — Detector is functioning as designed. Approve the pooled transfer manifest to release capital by end of Q1.",
    confidence: 0.86,
  },
];

// helper: build a downloadable CSV string from a report
export function reportToCsv(report) {
  const head = report.columns.join(",");
  const body = report.rows.map(r =>
    report.columnKeys.map(k => {
      const v = r[k];
      if (typeof v === "string" && v.includes(",")) return `"${v}"`;
      return v;
    }).join(",")
  ).join("\n");
  return head + "\n" + body + "\n";
}

export const REPORT_AUDIT_LOG = [
  { ts: "2026-02-18 07:00", report: "Branch Inventory Summary", actor: "scheduler@fabric", action: "Auto-generated", detail: "119 branches · 8 categories · 14,240 SKU-branch positions ingested · delivered to Pilot audience" },
  { ts: "2026-02-17 08:00", report: "Weekly AI Reorder Recommendations", actor: "scheduler@fabric", action: "Auto-generated", detail: "342 recommendations · 5 warehouse clusters · ML-001 v3.4 · confidence-weighted" },
  { ts: "2026-02-14 16:00", report: "Dead-Stock Candidate List — Pooled Transfer & Liquidation", actor: "scheduler@fabric", action: "Auto-generated", detail: "18 SKUs ≥180d DoH · ₱4.82M working capital · 12 pooled transfers · 6 Shopee liquidation" },
  { ts: "2026-02-18 06:00", report: "Daily Sales Summary", actor: "scheduler@fabric", action: "Auto-generated", detail: "158 branches · 12,840 transactions ingested · delivered to 22 recipients" },
  { ts: "2026-02-17 14:12", report: "Daily Sales Summary", actor: "danny@asterisk.com.sg", action: "Manual re-run", detail: "CFO requested intra-day refresh after Shopee anchor event close" },
  { ts: "2026-02-17 07:00", report: "Weekly Inventory Value Report", actor: "scheduler@fabric", action: "Auto-generated", detail: "Week 7 close · ₱928.4M total · 8 categories · 42 rows" },
  { ts: "2026-02-03 08:00", report: "Monthly Branch P&L Report", actor: "scheduler@fabric", action: "Auto-generated", detail: "January 2026 close · 158 branches · delivered to board pack" },
  { ts: "2026-01-12 09:00", report: "Quarterly Supplier Performance Report", actor: "procurement-ops", action: "Draft created", detail: "Q4 2025 scorecard · 38 suppliers · pending Procurement Manager review" },
];
